<template>
  <v-list-tile avatar>
    <v-list-tile-avatar class="mt-1">
      <template v-if="item.avatar">
        <img :src="item.avatar">
      </template>
      <template v-else>
        <v-icon color="grey"> {{icon}} </v-icon>
      </template>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title> {{item.name}} </v-list-tile-title>
      <v-list-tile-sub-title>
        <span class="main" :true-value="1" :false-value="0" v-if="item.main">CASA MATRIZ</span> {{item.address}}
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
        <v-icon color="grey lighten-1" @click="$emit('selected', item)">edit</v-icon>
        <v-icon v-if="!item.main" color="error lighten-1" @click="$emit('delete', item)">delete</v-icon>
    </v-list-tile-action>
  </v-list-tile>
</template>
<script>
export default {
  props: {
    item: {
      type: Object
    },
    text: {
      type: String
    },
    icon: {
      type: String
    },
    index: {
      type: Number,
      required: true
    },
    sucursalSeleccionada: {
      type: Number
    }
  },
  methods: {
    selectBranchOffice() {
      this.$store.commit('branches/selectBranch', {branch: this.item, index: this.index})
      this.$emit('selected')
    }
  },
}
</script>
<style scoped>
.main {
  background-color: grey;
  color: rgb(255, 255, 255);;
  padding:0 7px;
  border-radius: 25px;
  margin-right: 5px;
  font-size:11px;
}
</style>
